import { api, createCancelTokenHandler } from "../../vodea/services";

const endPoint = () => process.env.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  all: function (vendorId: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/vendor/${vendorId}/invoice-offer-log`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
          .token,
    });
  },
  show: function (
    vendorId: number | string,
    id: number | string,
    params: any = null
  ) {
    return api.get(
      `${endPoint()}/api/vendor/${vendorId}/invoice-offer-log/${id}`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[this.show.name].handleRequestCancellation()
            .token,
      }
    );
  },
  updateStatus: function (
    vendorId: number | string,
    id: number | string,
    status: string,
    params: any = null
  ) {
    return api.put(
      `${endPoint()}/api/vendor/${vendorId}/invoice-offer-log/${id}/status/${status}`,
      {
        params,
        cancelToken:
          cancelTokenHandlerObject[this.all.name].handleRequestCancellation()
            .token,
      }
    );
  },
};

export default Repository;

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);
